
import {
  defineComponent, ref,
} from 'vue';
import { Table, ConfigProvider, } from 'ant-design-vue';
import { useStore, } from 'vuex';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

export default defineComponent({
  components: {
    Table,
    ConfigProvider,
  },
  props: {
    areaTableData: {
      type: Array,
      default: () => [],
      requir: true,
    },
    columns: {
      type: Array,
      default: () => [],
      requir: true,
    },
    scrollHeight: {
      type: String,
      default: '2.3rem',
      requir: false,
    },
    pagination: {
      type: Object || Boolean,
      default: false,
      requir: false,
    },
  },
  setup (props, { emit, }) {
    // 当前页码
    const currentSize = ref<number>(1);
    // 每页展示条数
    const pageSize = ref<number>(10);

    // 表格页码改变处理事件
    const handleTableChange = (page: any, size: any): void => {
      currentSize.value = page;
      pageSize.value = size;
    };

    // 点击通知下发
    const handleDetail = (item?: any): void => {
      emit('showDetail', item);
    };

    return {
      zhCN,
      currentSize,
      pageSize,
      props,
      handleTableChange,
      handleDetail,
    };
  },
});
